export const COMPANY_NAME = 'RT Equipment & Haulage';

// Single source of truth for the marketing "stat" figures repeated across HomePage, AboutPage,
// and AuthLayout — update here once rather than in each page's own hardcoded copy.
export const PARISHES_SERVED = '14';
export const JOBS_COMPLETED = '200+';
export const QUOTE_TURNAROUND = '24hr';
export const OPERATING_SINCE = '2018';

// Bump whenever PrivacyPage/TermsPage's "Effective" date changes — recorded against
// each user's consent so we always know which policy text they actually agreed to.
export const PRIVACY_POLICY_VERSION = '2026-07-01';
